const { combineReducers } = require("redux");
const { proxyReducer } = require("./proxy.reducer");

const RootReducer = combineReducers({
    proxy: proxyReducer
});

export default RootReducer;